<script>
	export let bgColor = '#E5EFFC';
	export let textColor = '#78A9FF';
</script>

<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M20 0.5H4C1.79086 0.5 0 2.29086 0 4.5V20.5C0 22.7091 1.79086 24.5 4
    24.5H20C22.2091 24.5 24 22.7091 24 20.5V4.5C24 2.29086 22.2091 0.5 20 0.5Z"
		fill={bgColor}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M12.7716 7.25588C13.1894 7.25588 13.5281 7.59459 13.5281 8.01241C13.5281
    8.43023 13.1894 8.76894 12.7716 8.76894H6.58862C6.5473 8.76894 6.5138
    8.80244 6.5138 8.84376V17.9121C6.5138 17.9534 6.5473 17.9869 6.58862
    17.9869H15.6558C15.6972 17.9869 15.7307 17.9534 15.7307
    17.9121V11.7344C15.7307 11.3166 16.0694 10.9779 16.4872 10.9779C16.905
    10.9779 17.2437 11.3166 17.2437 11.7344V17.9121C17.2437 18.7891 16.5328 19.5
    15.6558 19.5H6.58862C5.71165 19.5 5.00073 18.7891 5.00073
    17.9121V8.84376C5.00073 7.9668 5.71165 7.25588 6.58862
    7.25588H12.7716ZM18.3713 5.5C18.7476 5.5 18.9995 5.75127 18.9995
    6.12817V8.64086C18.9995 8.89213 18.8732 9.1434 18.6226 9.20621C18.5591
    9.26903 18.4335 9.26903 18.3713 9.26903C18.1829 9.26903 18.0572 9.20621
    17.931 9.08058L17.3662 8.51522C17.3028 8.45241 17.1772 8.45241 17.115
    8.51522L12.655 12.9752C12.3409 13.2893 11.8383 13.2893 11.5243
    12.9752C11.2102 12.6612 11.2102 12.1586 11.5243 11.8445L15.9843
    7.38451C16.0465 7.3217 16.0465 7.19606 15.9843 7.13325L15.4183
    6.56789C15.2927 6.44226 15.2305 6.31662 15.2305 6.12817C15.2305 5.75127
    15.4817 5.5 15.8586 5.5H18.3713Z"
		fill={textColor}
	/>
</svg>
